<template>
  <base-modal :modal-id="'recommend-modal'" :is-modal-open="isOpen" hide-header hide-footer @hide="onCloseModal">
    <template #modal-body>
      <div class="recommend-content-wrp">
        <div class="recommend-header">
          <div class="text-recommend-header">
            <span>{{ 'คำแนะนำสำหรับการเลือกใช้สูตรการคำนวณอัตราการสูญเสียลูกค้า' }}</span>
            <div @click="onClickCancelButton" class="close-recommend-modal"><CloseIcon /></div>
          </div>
          <div class="text-recommend-header-detail">
            {{ 'การคำนวณอัตราการเลิกเป็นลูกค้า สามารถเลือกใช้สูตรได้ 2 รูปแบบ และควรเลือกใช้สูตรให้เหมาะสมกับธุรกิจ' }}
          </div>
        </div>
        <div class="text-recommend-detail">
          {{ 'สำหรับธุรกิจที่มี' }}<span style="color: #007fff">{{ ' จำนวนลูกค้าที่หายไปสูงกว่าจำนวนลูกค้าใหม่ ' }}</span>
          {{
            'เช่น ธุรกิจที่มีโมเดลธุรกิจ ไม่ใช่รูปแบบ subscription ร้านอาหารและเครื่องดื่ม หรือเปิดกิจการใหม่ ลูกค้ามีความภักดีต่อแบรนด์ (Loyalty) ในอัตราที่ต่ำอยู่ การเลือกใช้สูตรการคำนวณอัตราการสูญเสียลูกค้ากับแต่ละช่วงเวลาที่ต้องการดูผลลัพธ์ จะแตกต่างกันมาก'
          }}
        </div>
        <div class="text-recommend-detail">
          {{
            'สำหรับช่วงเวลา : วัน,สัปดาห์,เดือน และ ปี แนะนำให้เลือกใช้สูตร Standard Formula จะได้ผลลัพธ์ที่ค่อนข้างถูกต้องกว่า ดังตารางเปรียบเทียบการใช้ 2 สูตรในแต่ละช่วงเวลาที่กำหนด '
          }}
        </div>
        <div class="cards">
          <div class="left-cards">
            <div class="formula-detail">
              <img width="560" src="@assets/images/modules/analytics/recommend/Recommend-Timeframe-Day-a.png" alt="Timeframe-Day-a" />
            </div>
          </div>
          <div class="right-cards">
            <div class="formula-detail">
              <img width="560" src="@assets/images/modules/analytics/recommend/Recommend-Timeframe-Week-a.png" alt="Timeframe-Week-a" />
            </div>
          </div>
        </div>
        <div class="cards">
          <div class="left-cards">
            <div class="formula-detail">
              <img width="560" src="@assets/images/modules/analytics/recommend/Recommend-Timeframe-Month-a.png" alt="Timeframe-Month-a" />
            </div>
          </div>
          <div class="right-cards">
            <div class="formula-detail">
              <img width="560" src="@assets/images/modules/analytics/recommend/Recommend-Timeframe-Quater-a.png" alt="Timeframe-Quater-a" />
            </div>
          </div>
        </div>
        <div class="text-recommend-detail">
          {{ 'สำหรับธุรกิจที่มี'
          }}<span style="color: #007fff">{{ 'ดำเนินการมาระยะเวลาหนึ่งแล้ว และ จำนวนลูกค้าที่หายไปน้อยกว่าจำนวนลูกค้าใหม่' }}</span>
          {{ 'เช่น ธุรกิจที่มีโมเดลธุรกิจ แบบsubscription และมีอัตรการกลับมาใช้บริการซ้ำค่อนข้างสูง' }}
        </div>
        <div class="text-recommend-detail">
          {{ ' การเลือกใช้สูตรการคำนวณอัตราการสูญเสียลูกค้ากับแต่ละช่วงเวลาที่ต้องการดูผลลัพธ์ จะแตกต่างกันมาก' }}
        </div>
        <div class="text-recommend-detail">
          {{
            'สำหรับช่วงเวลา : วัน,สัปดาห์,เดือน และ ปี แนะนำให้เลือกใช้สูตร Adjusted Formula จะได้ผลลัพธ์ที่ค่อนข้างแม่นยำกว่า ดังตารางเปรียบเทียบการใช้ 2 สูตรในแต่ละช่วงเวลาที่กำหนด'
          }}
        </div>
        <div class="cards">
          <div class="left-cards">
            <div class="formula-detail">
              <img width="560" src="@assets/images/modules/analytics/recommend/Recommend-Timeframe-Day-b.png" alt="Timeframe-Day-b" />
            </div>
          </div>
          <div class="right-cards">
            <div class="formula-detail">
              <img width="560" src="@assets/images/modules/analytics/recommend/Recommend-Timeframe-Week-b.png" alt="Timeframe-Week-b" />
            </div>
          </div>
        </div>
        <div class="cards">
          <div class="left-cards">
            <div class="formula-detail">
              <img width="560" src="@assets/images/modules/analytics/recommend/Recommend-Timeframe-Month-b.png" alt="Timeframe-Month-b" />
            </div>
          </div>
          <div class="right-cards">
            <div class="formula-detail">
              <img width="560" src="@assets/images/modules/analytics/recommend/Recommend-Timeframe-Quater-b.png" alt="Timeframe-Quater-b" />
            </div>
          </div>
        </div>
      </div>
    </template>
  </base-modal>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import BaseModal from '@/views/components/modal/BaseModal.vue';
import CloseIcon from '@/assets/icons/modules/analytics/churn-rate/CloseIcon.vue';
import { getCurrentInstance, Ref, ref } from 'vue';

interface Props {
  isOpen: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  isOpen: false,
});
defineEmits(['close-modal', 'apply-modal']);

const { t } = useI18n();

const vm = getCurrentInstance()?.proxy;

function onClickCancelButton() {
  vm?.$emit('close-modal');
}

const onCloseModal = () => {
  vm?.$emit('close-modal');
};
</script>

<style lang="scss" scoped>
.icon-arrow {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100%;
}
.icon-arrow-up {
  transform: rotate(-270deg);
}
.icon-arrow-down {
  transform: rotate(-90deg);
}
:deep(.modal-inner) {
  width: 78rem !important;
  max-width: 78rem !important;
  max-height: 91vh !important;
}
.recommend-content-wrp {
  width: 100%;
  .recommend-header {
    text-align: center;
    margin-bottom: 20px;
    .text-recommend-header {
      display: flex;
      justify-content: space-between;
      font-family: Prompt;
      font-size: 22px;
      font-weight: 400;
      line-height: 37.8px;
      text-align: left;
      color: #000000;
      span {
        margin-left: 20px;
      }
      .close-recommend-modal {
        cursor: pointer;
      }
    }
    .text-recommend-header-detail {
      display: flex;
      flex-direction: column;
      margin-left: 20px;
      margin-bottom: 20px;
      font-family: Prompt;
      font-size: 16px;
      font-weight: 400;
      line-height: 24.19px;
      text-align: left;
      color: #606a6c;
    }
    .description-recommend-header {
      font-family: Prompt;
      font-size: 16px;
      font-weight: 400;
      line-height: 24.19px;
      text-align: left;
      color: #606a6c;
      margin-left: 20px;
      margin-bottom: 10px;
      .description-recommend-more {
        color: #007fff;
        cursor: pointer;
      }
    }
  }
  .text-recommend-detail {
    //styleName: Text Reg 16;
    font-family: Prompt;
    font-size: 16px;
    font-weight: 400;
    line-height: 24.19px;
    text-align: left;
    color: #606a6c;
    margin-left: 20px;
  }
  .cards {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    margin-left: 1rem;
    margin-right: 1rem;

    .card {
      border: 1px solid #b4b4b4;
      border-radius: 25px;
      height: 330px;
      width: 35rem;
      padding: 1.563rem;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      cursor: pointer;
      .card-header-cal {
        display: flex;
        justify-content: space-between;
        span {
          font-family: Prompt;
          font-size: 20px;
          font-weight: 400;
          line-height: 30.24px;
          text-align: left;
        }
        .icon-expand {
          fill: #2d2d2d;
        }
      }

      .card-body-cal {
        p {
          font-family: Prompt;
          font-size: 14px;
          font-weight: 300;
          line-height: 21.17px;
          text-align: left;

          color: #606a6c;
        }
        .formula {
          border-radius: 20px;
          .formula-title {
            font-family: Prompt;
            font-size: 18px;
            font-style: italic;
            font-weight: 400;
            line-height: 22.68px;
            text-align: left;
            color: #5180ae;
          }
        }
      }
    }

    .card-active {
      border: 6px solid #007fff;
      border-radius: 25px;
      width: 35rem;
      height: 330px;
      padding: 1.563rem;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
      background-color: #f9fbff;
      cursor: pointer;
      .card-header-cal {
        display: flex;
        justify-content: space-between;
        span {
          font-family: Prompt;
          font-size: 20px;
          font-weight: 400;
          line-height: 30.24px;
          text-align: left;
        }
        .icon-expand {
          fill: #007fff;
        }
      }

      .card-body-cal {
        p {
          font-family: Prompt;
          font-size: 14px;
          font-weight: 300;
          line-height: 21.17px;
          text-align: left;

          color: #606a6c;
        }
        .formula {
          border-radius: 20px;
          .formula-title {
            font-family: Prompt;
            font-size: 18px;
            font-style: italic;
            font-weight: 400;
            line-height: 22.68px;
            text-align: left;
            color: #5180ae;
          }
        }
      }
    }
    .formula-detail {
      margin-top: 1rem;
      width: 35rem;
    }
  }
}
</style>
